/* Rideau Rempart : selecteur rapide d'ajout au panier (boutons "+" des cartes produit).
   Clic sur [data-rr-add] : panneau coloris + taille dans la carte, ajout via /cart/add.js,
   puis evenement natif du theme "cart:updated" (compteur + ouverture du tiroir panier). */
(function () {
  if (window.__rrQuickAdd) return;
  window.__rrQuickAdd = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CARD = '.rr-pc__card, .rr-pcard';
  var FRAME = '.rr-pc__media, .rr-pcard__frame';
  var ICON_X = '<svg class="rr-glyph" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false" style="overflow:visible"><text class="material-symbols-outlined notranslate" translate="no" x="12" y="12" text-anchor="middle" dominant-baseline="central" style="font-size:24px;fill:currentColor;stroke:none">close</text></svg>';
  var ICON_OK = '<svg class="rr-glyph" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false" style="overflow:visible"><text class="material-symbols-outlined notranslate" translate="no" x="12" y="12" text-anchor="middle" dominant-baseline="central" style="font-size:24px;fill:currentColor;stroke:none">check</text></svg>';
  var cache = {};
  var cur = null;
  var uid = 0;
  var down = null;
  var hoverT = 0;
  var hoverC = null;

  function reduced() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function mk(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function money(cents) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || (window.Theme && Theme.currency) || 'EUR';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: code, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return (whole ? String(cents / 100) : (cents / 100).toFixed(2).replace('.', ',')) + '\u00A0\u20AC';
    }
  }

  /* ---------- donnees ---------- */
  function entry(h) { return cache[h] || (cache[h] = {}); }
  function loadProduct(h, fresh) {
    var c = entry(h);
    if (fresh || !c.p) {
      c.p = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
        .catch(function (e) { c.p = null; throw e; });
    }
    return c.p;
  }
  function okBg(v) {
    v = (v || '').trim();
    return /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\([0-9a-z\s.,%\/-]+\)|url\(\s*["']?(https?:)?\/\/[^"')\s]+["']?\s*\))$/i.test(v) ? v : '';
  }
  /* Couleurs / echantillons : lus dans le selecteur de variantes de la fiche produit (meme source que la fiche). */
  function parseSwatches(html) {
    var map = {};
    var d = new DOMParser().parseFromString(html, 'text/html');
    d.querySelectorAll('input.rr-vp__input').forEach(function (inp) {
      var name = (inp.name || '').replace(/^option-/, '');
      var lab = inp.id ? d.querySelector('label[for="' + inp.id + '"]') : null;
      var dot = lab && lab.querySelector('.rr-vp__dot');
      var m = dot && /--sw\s*:\s*([^;]+)/.exec(dot.getAttribute('style') || '');
      var bg = m ? okBg(m[1]) : '';
      if (bg) (map[name] = map[name] || {})[inp.value] = bg;
    });
    return map;
  }
  function loadSwatches(h, href) {
    var c = entry(h);
    if (!c.s) {
      c.s = fetch(href, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
        .then(parseSwatches)
        .catch(function () { c.s = null; return {}; });
    }
    return c.s;
  }
  /* Pastilles deja affichees dans la carte (accueil) : repli si la fiche n'a rien donne. */
  function cardSwatches(card) {
    var map = {};
    if (!card) return map;
    card.querySelectorAll('.rr-pc__sw li[title]').forEach(function (li) {
      var c = okBg(li.style.getPropertyValue('--sw'));
      if (c) map[li.getAttribute('title')] = c;
    });
    return map;
  }
  function warm(btn, full) {
    var h = btn.dataset && btn.dataset.handle;
    if (!h) return;
    loadProduct(h).catch(function () {});
    if (full) loadSwatches(h, btn.href);
  }

  /* ---------- variantes ---------- */
  function optionsOf(p) {
    return (p.options || []).map(function (o, i) {
      if (typeof o === 'string') {
        var vals = [];
        p.variants.forEach(function (v) { var x = v['option' + (i + 1)]; if (x != null && vals.indexOf(x) < 0) vals.push(x); });
        return { name: o, values: vals };
      }
      return { name: o.name, values: o.values.slice() };
    });
  }
  function variantFor(ctx) {
    var vs = ctx.product.variants;
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var k = 0; k < ctx.sel.length; k++) { if (vs[i]['option' + (k + 1)] !== ctx.sel[k]) { ok = false; break; } }
      if (ok) return vs[i];
    }
    return null;
  }
  function availWith(ctx, gi, val) {
    var vs = ctx.product.variants;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (!v.available || v['option' + (gi + 1)] !== val) continue;
      var ok = true;
      for (var k = 0; k < ctx.sel.length; k++) { if (k !== gi && v['option' + (k + 1)] !== ctx.sel[k]) { ok = false; break; } }
      if (ok) return true;
    }
    return false;
  }

  /* ---------- panneau ---------- */
  function shell(ctx) {
    var name = '';
    var t = ctx.card && ctx.card.querySelector('.rr-pc__name, .rr-pcard__title');
    if (t) name = t.textContent.replace(/\s+/g, ' ').trim();
    var el = mk('div', 'rr-qa');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'Choisir la taille et le coloris');
    el.tabIndex = -1;
    var inner = mk('div', 'rr-qa__in');
    var head = mk('div', 'rr-qa__head');
    var id = mk('div', 'rr-qa__id');
    ctx.title = mk('p', 'rr-qa__title', name);
    if (name) ctx.title.title = name;
    ctx.price = mk('p', 'rr-qa__price');
    id.appendChild(ctx.title);
    id.appendChild(ctx.price);
    ctx.closeBtn = mk('button', 'rr-qa__close');
    ctx.closeBtn.type = 'button';
    ctx.closeBtn.setAttribute('aria-label', 'Fermer');
    ctx.closeBtn.innerHTML = ICON_X;
    head.appendChild(id);
    head.appendChild(ctx.closeBtn);
    ctx.body = mk('div', 'rr-qa__body');
    ctx.body.setAttribute('aria-busy', 'true');
    ctx.body.appendChild(mk('p', 'rr-qa__load', 'Chargement des options\u2026'));
    var foot = mk('div', 'rr-qa__foot');
    ctx.cta = mk('button', 'rr-qa__cta');
    ctx.cta.type = 'button';
    ctx.ctaIc = mk('span', 'rr-qa__ctaic');
    ctx.ctaIc.innerHTML = ICON_OK;
    ctx.ctaIc.hidden = true;
    ctx.ctaTxt = mk('span', 'rr-qa__ctatx', 'Ajouter au panier');
    ctx.cta.appendChild(ctx.ctaIc);
    ctx.cta.appendChild(ctx.ctaTxt);
    ctx.err = mk('p', 'rr-qa__err');
    ctx.err.setAttribute('role', 'alert');
    ctx.sr = mk('p', 'rr-qa__sr');
    ctx.sr.setAttribute('role', 'status');
    foot.appendChild(ctx.cta);
    foot.appendChild(ctx.err);
    foot.appendChild(ctx.sr);
    inner.appendChild(head);
    inner.appendChild(ctx.body);
    inner.appendChild(foot);
    el.appendChild(inner);
    ctx.el = el;
    el.addEventListener('click', function (e) {
      var chip = e.target.closest('.rr-qa__chip');
      if (chip && el.contains(chip)) { pick(ctx, +chip.parentNode.getAttribute('data-g'), chip.getAttribute('data-v')); return; }
      if (e.target.closest('.rr-qa__close')) { close(ctx, { focus: true }); return; }
      if (e.target.closest('.rr-qa__cta')) add(ctx);
    });
    ctx.onScroll = function () { more(ctx); };
    ctx.body.addEventListener('scroll', ctx.onScroll, { passive: true });
    window.addEventListener('resize', ctx.onScroll);
  }

  function more(ctx) {
    var b = ctx.body;
    if (b) b.classList.toggle('has-more', b.scrollHeight - b.scrollTop - b.clientHeight > 4);
  }

  function render(ctx, p, pdp) {
    ctx.product = p;
    ctx.opts = p.variants.length > 1 ? optionsOf(p) : [];
    var first = null;
    for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { first = p.variants[i]; break; } }
    first = first || p.variants[0];
    ctx.sel = ctx.opts.map(function (o, k) { return first['option' + (k + 1)]; });
    var onCard = cardSwatches(ctx.card);
    ctx.groups = [];
    ctx.body.textContent = '';
    ctx.body.removeAttribute('aria-busy');
    ctx.opts.forEach(function (o, gi) {
      var g = mk('div', 'rr-qa__grp');
      var labId = 'rr-qa-' + ctx.id + '-' + gi;
      var cm = o.values.length > 0 && o.values.every(function (v) { return /\s+cm$/i.test(v); });
      var lab = mk('div', 'rr-qa__lab');
      var nm = mk('span', 'rr-qa__name', o.name + (cm ? ' (cm)' : ''));
      nm.id = labId;
      var val = mk('span', 'rr-qa__val');
      lab.appendChild(nm);
      lab.appendChild(val);
      var list = mk('div', 'rr-qa__opts');
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-labelledby', labId);
      list.setAttribute('data-g', String(gi));
      var isColor = /coloris|couleur|colou?r/i.test(o.name);
      var bgs = o.values.map(function (v) { return (pdp && pdp[o.name] && pdp[o.name][v]) || onCard[v] || ''; });
      var dots = isColor && bgs.length > 0 && bgs.every(Boolean);
      if (dots) list.className += ' rr-qa__opts--sw';
      else g.className += ' rr-qa__grp--txt';
      var chips = o.values.map(function (v, vi) {
        var b = mk('button', 'rr-qa__chip');
        b.type = 'button';
        b.setAttribute('role', 'radio');
        b.setAttribute('data-v', v);
        if (dots) {
          b.className += ' rr-qa__chip--sw';
          var d = mk('span', 'rr-qa__dot');
          d.style.setProperty('--sw', bgs[vi]);
          b.appendChild(d);
          b.title = v;
        } else {
          b.textContent = cm ? v.replace(/\s+cm$/i, '') : v;
        }
        list.appendChild(b);
        return b;
      });
      g.appendChild(lab);
      g.appendChild(list);
      ctx.body.appendChild(g);
      ctx.groups.push({ chips: chips, val: val });
    });
    ctx.state = 'idle';
    sync(ctx);
    if (ctx.el.contains(document.activeElement) || document.activeElement === document.body) {
      var f = ctx.groups.length ? ctx.groups[0].chips.filter(function (c) { return c.getAttribute('aria-checked') === 'true'; })[0] : ctx.cta;
      if (f) f.focus({ preventScroll: true });
    }
    requestAnimationFrame(function () { more(ctx); });
  }

  function sync(ctx) {
    if (ctx.groups) {
      ctx.groups.forEach(function (g, gi) {
        g.chips.forEach(function (b) {
          var v = b.getAttribute('data-v');
          var on = v === ctx.sel[gi];
          var oos = !availWith(ctx, gi, v);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          b.classList.toggle('is-oos', oos);
          b.setAttribute('aria-label', v + (oos ? ' (indisponible)' : ''));
        });
        g.val.textContent = ctx.sel[gi];
      });
    }
    paint(ctx);
  }

  function paint(ctx) {
    var v = ctx.product ? variantFor(ctx) : null;
    var ok = !!(v && v.available);
    var s = ctx.state;
    ctx.price.textContent = '';
    if (v && ok) {
      ctx.price.appendChild(document.createTextNode(money(v.price)));
      if (v.compare_at_price && v.compare_at_price > v.price) ctx.price.appendChild(mk('s', '', money(v.compare_at_price)));
    } else if (v) {
      ctx.price.textContent = 'Indisponible';
    }
    ctx.cta.classList.toggle('is-ok', s === 'ok');
    ctx.cta.classList.toggle('is-busy', s === 'busy');
    ctx.cta.setAttribute('aria-disabled', s !== 'idle' || !ok ? 'true' : 'false');
    ctx.ctaIc.hidden = s !== 'ok';
    ctx.ctaTxt.textContent = s === 'ok' ? 'Ajout\u00E9' : s === 'busy' ? 'Ajout\u2026' : (s === 'idle' && !ok) ? 'Indisponible' : 'Ajouter au panier';
  }

  function pick(ctx, gi, val) {
    if (ctx.state !== 'idle' && ctx.state !== 'wait') return;
    if (!ctx.sel || ctx.sel[gi] == null) return;
    ctx.sel[gi] = val;
    setErr(ctx, '');
    sync(ctx);
  }
  function setErr(ctx, msg) { ctx.err.textContent = msg; }

  /* ---------- ajout ---------- */
  function sectionsFor(sid) {
    if (!sid) return Promise.resolve({});
    return fetch(ROOT + '?sections=' + encodeURIComponent(sid), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).catch(function () { return {}; });
  }
  function announce(count, sections) {
    if (!document.querySelector('cart-drawer')) {
      window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || (ROOT + 'cart');
      return;
    }
    if (count == null) {
      var ic = document.querySelector('cart-icon');
      var n = ic && ic.getCurrentItemCount ? ic.getCurrentItemCount() : NaN;
      count = (n >= 0 ? n : 0) + 1;
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { resource: {}, data: { itemCount: count, source: 'rr-quick-add', sections: sections || {} } } }));
  }
  function add(ctx) {
    var v = ctx.product ? variantFor(ctx) : null;
    if (!v || !v.available || ctx.state !== 'idle') return;
    ctx.state = 'busy';
    setErr(ctx, '');
    paint(ctx);
    var drawer = document.querySelector('cart-drawer');
    var sid = drawer && drawer.dataset.sectionId;
    var body = { items: [{ id: v.id, quantity: 1 }] };
    if (sid) body.sections = sid;
    var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || (ROOT + 'cart/add.js');
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) { var e = new Error('add'); e.status = r.status; throw e; }
          return j;
        });
      })
      .then(function (j) {
        ctx.state = 'ok';
        paint(ctx);
        ctx.sr.textContent = 'Ajout\u00E9 au panier';
        var count = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); }).then(function (c) { return c.item_count; }).catch(function () { return null; });
        var secs = j && j.sections ? Promise.resolve(j.sections) : sectionsFor(sid);
        ctx.after = function () { Promise.all([count, secs]).then(function (a) { announce(a[0], a[1]); }); };
        ctx.timer = setTimeout(function () { close(ctx, { focus: true }); }, 1200);
      })
      .catch(function (e) {
        ctx.state = 'idle';
        if (e && e.status === 422) {
          v.available = false;
          setErr(ctx, "Cette taille n’est plus disponible. Choisissez-en une autre.");
          loadProduct(ctx.handle, true).then(function (p) { if (!ctx.closed) { ctx.product = p; sync(ctx); } }).catch(function () {});
        } else {
          setErr(ctx, "L’ajout n’a pas abouti. V\u00E9rifiez votre connexion et r\u00E9essayez.");
        }
        sync(ctx);
      });
  }

  /* ---------- ouverture / fermeture ---------- */
  function hostFor(btn) {
    var frame = btn.closest(FRAME);
    var card = btn.closest(CARD);
    if (frame && frame.clientWidth >= 260) return { host: frame, card: card || frame };
    var h = card || frame;
    return h ? { host: h, card: h } : null;
  }
  function open(btn) {
    var h = btn.dataset.handle;
    var where = hostFor(btn);
    if (!h || !where) return false;
    if (cur) close(cur, { focus: false, instant: true });
    var ctx = { id: ++uid, btn: btn, handle: h, host: where.host, card: where.card, state: 'wait' };
    shell(ctx);
    if (where.host === where.card) ctx.el.className += ' rr-qa--card';
    paint(ctx);
    ctx.host.classList.add('rr-qa-host');
    ctx.card.classList.add('rr-qa-open');
    ctx.host.appendChild(ctx.el);
    btn.setAttribute('aria-expanded', 'true');
    cur = ctx;
    ctx.el.focus({ preventScroll: true });
    void ctx.el.offsetWidth;
    ctx.el.classList.add('is-in');
    var wait = new Promise(function (r) { setTimeout(function () { r({}); }, 2500); });
    Promise.all([loadProduct(h), Promise.race([loadSwatches(h, btn.href), wait])])
      .then(function (r) { if (!ctx.closed) render(ctx, r[0], r[1]); })
      .catch(function () {
        if (ctx.closed) return;
        close(ctx, { focus: false, instant: true });
        window.location.href = btn.href;
      });
    return true;
  }
  function close(ctx, o) {
    o = o || {};
    if (!ctx || ctx.closed) return;
    ctx.closed = true;
    if (cur === ctx) cur = null;
    clearTimeout(ctx.timer);
    window.removeEventListener('resize', ctx.onScroll);
    var after = ctx.after;
    ctx.after = null;
    var had = ctx.el.contains(document.activeElement);
    ctx.btn.setAttribute('aria-expanded', 'false');
    ctx.card.classList.remove('rr-qa-open');
    var done = function () {
      if (ctx.el.parentNode) ctx.el.parentNode.removeChild(ctx.el);
      if (!cur || cur.host !== ctx.host) ctx.host.classList.remove('rr-qa-host');
    };
    if (o.instant || reduced()) {
      done();
    } else {
      ctx.el.classList.remove('is-in');
      ctx.el.classList.add('is-out');
      setTimeout(done, 200);
    }
    if (o.focus !== false && had) ctx.btn.focus({ preventScroll: true });
    if (after) after();
  }

  function trap(e) {
    var list = Array.prototype.filter.call(cur.el.querySelectorAll('button'), function (b) { return b.tabIndex >= 0 && b.getAttribute('aria-disabled') !== 'true'; });
    if (!list.length) { e.preventDefault(); cur.el.focus({ preventScroll: true }); return; }
    var i = list.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); list[list.length - 1].focus(); }
    else if (!e.shiftKey && (i === list.length - 1 || i < 0)) { e.preventDefault(); list[0].focus(); }
  }
  function radioKey(e) {
    var chip = e.target.closest && e.target.closest('.rr-qa__chip');
    if (!chip || !cur.el.contains(chip)) return false;
    var k = e.key, dir = 0, abs = -1;
    if (k === 'ArrowRight' || k === 'ArrowDown') dir = 1;
    else if (k === 'ArrowLeft' || k === 'ArrowUp') dir = -1;
    else if (k === 'Home') abs = 0;
    else if (k === 'End') abs = 9999;
    else return false;
    var chips = Array.prototype.slice.call(chip.parentNode.children);
    var i = chips.indexOf(chip);
    var n = abs >= 0 ? Math.min(abs, chips.length - 1) : (i + dir + chips.length) % chips.length;
    e.preventDefault();
    pick(cur, +chip.parentNode.getAttribute('data-g'), chips[n].getAttribute('data-v'));
    chips[n].focus();
    return true;
  }

  /* ---------- ecouteurs delegues ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rr-add]');
    if (!btn || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (open(btn)) e.preventDefault();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!cur) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(cur, { focus: true }); return; }
    if (e.key === 'Tab') { trap(e); return; }
    radioKey(e);
  }, true);
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    var b = t.closest && t.closest('[data-rr-add]');
    if (b) warm(b, true);
    down = cur && !cur.el.contains(t) ? { x: e.clientX, y: e.clientY } : null;
  }, true);
  document.addEventListener('pointerup', function (e) {
    if (!down) return;
    var d = down;
    down = null;
    if (cur && !cur.el.contains(e.target) && Math.abs(e.clientX - d.x) < 10 && Math.abs(e.clientY - d.y) < 10) close(cur, { focus: false });
  }, true);
  document.addEventListener('pointercancel', function () { down = null; }, true);
  document.addEventListener('focusin', function (e) {
    var b = e.target.closest && e.target.closest('[data-rr-add]');
    if (b) warm(b, true);
  }, true);
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch' || !e.target.closest) return;
    var b = e.target.closest('[data-rr-add]');
    if (b) { warm(b, true); return; }
    var card = e.target.closest(CARD);
    if (!card || card === hoverC) return;
    hoverC = card;
    clearTimeout(hoverT);
    hoverT = setTimeout(function () { var x = card.querySelector('[data-rr-add]'); if (x) warm(x, false); }, 140);
  }, true);
  document.addEventListener('shopify:section:unload', function () { if (cur) close(cur, { focus: false, instant: true }); });

  function flag() {
    document.querySelectorAll('[data-rr-add]').forEach(function (a) { a.setAttribute('aria-haspopup', 'dialog'); if (!a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false'); });
  }
  flag();
  window.addEventListener('load', flag);
  document.addEventListener('shopify:section:load', flag);
})();

/* Selecteur de taille : accessibilite et visibilite sous l'en-tete collant (ajoute le 25/10/2026) */
(function () {
  if (window.__rrQuickAddA11y) return;
  window.__rrQuickAddA11y = true;
  var ADD = '[data-rr-add]';
  var IMG_LINKS = '.rr-pcard__media, .rr-pc__imglink';
  var n = 0, queued = false;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Bas reel de l'en-tete collant, une fois colle en haut de l'ecran */
  function headerBottom() {
    var max = 0;
    Array.prototype.forEach.call(document.querySelectorAll('header, sticky-header, .shopify-section-group-header-group'), function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height < 20 || r.height > 260 || r.width < window.innerWidth * 0.5) return;
      var top = parseFloat(cs.top);
      var b = (isNaN(top) ? 0 : top) + r.height;
      if (b > max) max = b;
    });
    return max || 66;
  }

  /* Fait defiler la page juste ce qu'il faut pour que tout le panneau soit visible sous l'en-tete */
  function reveal(panel) {
    var host = panel.parentElement;
    if (!host) return;
    var r = host.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var minTop = headerBottom() + 12;
    var maxBottom = vh - 12;
    var dy = 0;
    if (r.top < minTop) dy = r.top - minTop;
    else if (r.bottom > maxBottom) dy = Math.min(r.bottom - maxBottom, r.top - minTop);
    if (Math.abs(dy) < 1) return;
    window.scrollBy({ top: dy, left: 0, behavior: reduced() ? 'auto' : 'smooth' });
  }

  function enhancePanel(el) {
    if (el.getAttribute('data-rr-a11y')) return;
    el.setAttribute('data-rr-a11y', '1');
    var t = el.querySelector('.rr-qa__title');
    if (t && t.textContent.replace(/\s+/g, '') !== '') {
      if (!t.id) t.id = 'rr-qa-title-' + (++n);
      el.setAttribute('aria-labelledby', t.id);
    }
    reveal(el);
  }

  /* Le plus est un lien : on lui donne le role bouton ; le lien image, redondant avec le titre, sort de la tabulation */
  function prep() {
    queued = false;
    Array.prototype.forEach.call(document.querySelectorAll(ADD), function (a) {
      if (!a.hasAttribute('role')) a.setAttribute('role', 'button');
    });
    Array.prototype.forEach.call(document.querySelectorAll(IMG_LINKS), function (a) {
      if (a.getAttribute('tabindex') !== '-1') a.setAttribute('tabindex', '-1');
      if (a.getAttribute('aria-hidden') !== 'true') a.setAttribute('aria-hidden', 'true');
    });
  }
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(prep);
  }

  function onMut(muts) {
    var dirty = false;
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var nd = added[j];
        if (nd.nodeType !== 1) continue;
        if (nd.classList.contains('rr-qa')) { enhancePanel(nd); continue; }
        var p = nd.querySelector('.rr-qa');
        if (p) enhancePanel(p);
        if (nd.matches(ADD + ',' + IMG_LINKS) || nd.querySelector(ADD + ',' + IMG_LINKS)) dirty = true;
      }
    }
    if (dirty) queue();
  }

  /* Espace active le plus comme un bouton (Entree fonctionne deja sur un lien) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    var t = e.target;
    var b = t && t.closest ? t.closest(ADD) : null;
    if (!b || b.tagName === 'BUTTON') return;
    e.preventDefault();
    if (!e.repeat) b.click();
  });

  function start() {
    prep();
    new MutationObserver(onMut).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', queue);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* Accessibilité globale (passe design) : Échap ferme les filtres de collection ; les pictogrammes Material Symbols ajoutés par script restent muets pour les lecteurs d'écran. Garde-fou window.__rrA11y. */
(function () {
  if (window.__rrA11y) return;
  window.__rrA11y = true;

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('.rr-fl details[open], details.rr-fl[open]');
    if (!open.length) return;
    var focused = document.activeElement;
    var target = null;
    open.forEach(function (d) {
      if (d.contains(focused)) target = d;
      d.open = false;
    });
    var summary = target && target.querySelector('summary');
    if (summary) summary.focus();
  });

  function hideIcons(root) {
    if (!root || !root.querySelectorAll) return;
    var list = root.matches && root.matches('span[class*="material-symbols"]') ? [root] : [];
    root.querySelectorAll('span[class*="material-symbols"]:not([aria-hidden])').forEach(function (n) {
      list.push(n);
    });
    list.forEach(function (n) {
      if (n.getAttribute('aria-hidden') !== 'true') n.setAttribute('aria-hidden', 'true');
    });
  }

  hideIcons(document);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) hideIcons(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
